import React, { useState } from "react";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { CircularProgress, IconButton } from "@mui/material";
import { functions } from "firebaseApp";
import { httpsCallable } from "firebase/functions";
import { useDispatch } from "react-redux";
import { popupActions } from "store/react-lib/generic-ui/popup";
import { updateDoc } from "firebase/firestore";

export default function GenerateAudioButtonV2({ text, docRef }) {

  const [generatingAudio, setGeneratingAudio] = useState(false);
  const dispatch = useDispatch();

  const handleGenerateAudio = async () => {
    try {
      setGeneratingAudio(true);
      updateDoc(docRef, {
        generatingAudio: true,
      });
      const res = await httpsCallable(
        functions,
        "textToSpeech"
      )({
        text,
      });
      const resData = res.data;
      if(!resData.success) {
        dispatch(popupActions.showError(resData.error));
      } else {
        updateDoc(docRef, {
          generatingAudio: false,
          audioUrl: resData.url,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch(popupActions.showError("Internal error."));
    } finally {
      setGeneratingAudio(false);
    }
  };

  return (
    <IconButton disabled={generatingAudio} onClick={handleGenerateAudio}>
      {generatingAudio ? <CircularProgress size={24} color="secondary" /> : <VolumeUpIcon />}
    </IconButton>
  );
}
